export default __webpack_public_path__ + "static/empty_news-9add157cdd5deba3a8a84efe690dbeca.jpg";